export default __webpack_public_path__ + "static/media/vault.745b31fd.svg";